// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"a2ac092f","213":"39186920","453":"255c5569","455":"52e780c7"}[chunkId] + ".chunk.js";
};